import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DashboardInfoModelComponent } from '../../../dashboard/dashboard-info-model/dashboard-info-model.component';

@Component({
  selector: 'app-info-graph-model',
  templateUrl: './info-graph-model.component.html',
  styleUrl: './info-graph-model.component.scss'
})
export class InfoGraphModelComponent {

  constructor(private dialogRef: MatDialogRef<DashboardInfoModelComponent>) { }

  close() {
    this.dialogRef.close();
  }


}